import * as React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import HistoryIcon from '@mui/icons-material/History'
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined'
import ContactPageIcon from '@mui/icons-material/ContactPage'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import Share from '@mui/icons-material/Share'
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove'
import HomeIcon from '@mui/icons-material/Home'
import LockIcon from '@mui/icons-material/Lock'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import FolderIcon from '@mui/icons-material/Folder'
import ShareIcon from '@mui/icons-material/Share';

import Link from '~/client/components/Link'

export default function SideNav({ currentUser }) {
  return <Box sx={{
    width: 'var(--side-nav-width)',
    flex: `0 0 var(--side-nav-width)`,
    // backgroundColor: 'secondary.dark',
    // backgroundColor: '#181818',
    // backgroundColor: '#181818',
    zIndex: 10,
  }}>
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      top: '70px',
      left: 0,
      right: 0,
      width: 'var(--side-nav-width)',
      height: 'calc(100vh - 70px)',
      // backgroundColor: '#181818',
      backgroundColor: 'secondary.dark',
      overflowX: 'auto',
    }}>
      <List sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1',
        padding: '0',
      }}>
        <NavButton {...{text: 'Home', to: '/', icon: <HomeIcon/>}}/>
        {/*<NavButton {...{text: 'Default Profile', to: '/profile', icon: <PersonIcon/>}}/>*/}
        <NavButton {...{text: 'Data', to: '/data', icon: <DriveFileMoveIcon/>}}/>
        <NavButton {...{text: 'Connections', to: '/connections', icon: <ShareIcon/>}}/>
        {/*<NavButton {...{text: 'Apps', to: '/apps', icon: <PersonIcon/>}}/>*/}
        {/*<NavButton {...{text: 'Agreements', to: '/agreements', icon: <ContactPageIcon/>}}/>*/}
        {/*<NavButton {...{text: 'Notifications', to: '/notifications', icon: <NotificationsActiveIcon/>}}/>*/}
        <NavButton {...{text: 'History', to: '/history', icon: <HistoryIcon/>}}/>
        {/*<NavButton {...{text: 'Settings', to: '/settings', icon: <PersonIcon/>}}/>*/}
      </List>
    </Box>
  </Box>
}

function NavButton({ text, icon, ...props }){
  if (props.to) props.component ??= Link
  return <ListItem key={text} disablePadding>
    <ListItemButton {...props} sx={{
      userSelect: 'none',
      WebkitUserDrag: 'none',
    }}>
      <ListItemIcon sx={{minWidth: '30px'}}>
        {icon}
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  </ListItem>
}
